// extracted by mini-css-extract-plugin
module.exports = {"page_header":"_Oo_rB6s2"};